<template>
  <div
    v-if="content !== null"
    class="home-hero"
  >
    <div
      class="home-hero__full-size-image-wrapper"
      v-show="content.FSTwave !== null"
    >
      <ResponsiveImage :picture="content.Image" />
      <div class="home-hero__full-size-image-wrapper__wave pure-u-1">
        <WaveWhite
          class="w-full"
          v-show="content.FSTwave"
          :alt="$tv('waveAltText', 'home')"
        />
      </div>
    </div>
    <div
      v-if="content.LeftText"
      class="home-hero__left-text"
      :class="{'home-hero__left-text--light': content.TextAppearance === 'Light'}"
    >
      <p v-text="content.LeftText" />
    </div>
    <div
      class="home-hero__text"
      :class="{
        'home-hero__text--light': content.TextAppearance === 'Light',
        'home-hero__text--corteco': content.LeftText
      }"
    >
      <div
        v-if="content.Subline"
        class="home-hero__text__subline"
        v-text="content.Subline"
      />
      <div>
        <h1
          v-if="content.Header"
          class="h1 h1--underline"
          v-text="content.Header"
        />
      </div>
      <div
        class="home-hero__text__btn-container"
        :class="{'home-hero__text__btn-container--non-english': content.isFNLubeBanner && content.IsNonEnglish}"
      >
        <a
          v-if="content.Link"
          :href="content.Link"
          class="home-hero__text__btn-container__btn k-button k-button-md k-button-solid k-button-solid-primary"
        >
          <span v-text="buttonText" />
        </a>
        <a
          v-if="content.SecondaryLink"
          :href="content.SecondaryLink"
          :class="content.isFNLubeBanner ? 'home-hero__text__btn-container__text-link' : 'home-hero__text__btn-container__btn k-button k-button-md k-button-solid k-button-solid-base'"
        >
          <span v-text="secondaryButtonText" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import ResponsiveImage from '~/components/responsive-image'
import WaveWhite from '~/assets/images/wave-white.svg?component'

export default {
  components: {ResponsiveImage, WaveWhite},
  props: {
    content: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data() {
    return {
      BASE_URL: useRuntimeConfig().public.BASE_URL
    }
  },
  computed: {
    buttonText () {
      if (this.content?.ButtonLabel) {
        return this.content.ButtonLabel
      }
      return this.$tv('learnMore', 'home')
    },
    secondaryButtonText () {
      if (this.content?.SecondaryButtonLabel) {
        return this.content.SecondaryButtonLabel
      }
      return this.$tv('showAllProducts', 'home')
    }
  }
}
</script>

<style lang="scss">
  .home-hero {
    position: relative;

    &__full-size-image-wrapper {
      position: relative;

      picture {
        display: block;
      }

      svg.icon--svg {
        width: 100%;
      }

      &__wave {
        position: absolute;
        bottom: 0;

        img {
          max-width: 100%;
        }

        @include breakpoint-down($md) {
          display: none;
        }
      }
    }

    &__left-text {
      color: $color__white;
      font-size: 0.875rem;
      line-height: 1.138rem;
      position: absolute;
      bottom: 1.688em;
      left: 5rem;
      width: 16rem;

      @include breakpoint-down($between_md_lg) {
        display: none;
      }

      p {
        margin: 0;
        font-weight: $base-text-font-weight-semi-bold;
      }
    }

    &__text {
      width: calc(100% - 2rem);
      color: $color__primary;

      @include breakpoint-up($between_md_lg) {
        position: absolute;
        top: .625rem;
        right: 2rem;
        width: 30rem;
      }

      @include breakpoint-down($between_md_lg) {
        font-size: $base-text-font-size;
        padding: $default-margin-padding-width;
      }

      @include breakpoint-between($md, $between_md_lg) {
        font-size: $base-text-font-size;
        padding: $default-margin-padding-width 2rem;
      }

      &__subline {
        text-transform: uppercase;
      }

      h1 {
        margin-top: .75rem;
        overflow-wrap: break-word;
        word-break: auto-phrase;

        @include breakpoint-down($md) {
          font-size: $heading-h4-font-size;
        }
      }

      &__btn-container {
        display: inline-flex;
        gap: 0.75rem;
        justify-content: flex-end;
        flex-wrap: wrap;

        &__btn.k-button {
          margin-top: 2rem;

          .home-hero__text--corteco & {
            margin-top: 1rem;
          }

          .home-hero__text__btn-container--non-english & {
            margin-top: 1rem;
          }

          .k-button-solid-primary {
            color: $color__fst_gray__100;
          }

          @include breakpoint-down($between_md_lg) {
            margin-top: 1rem;
          }
        }

        &__text-link {
          position: absolute;
          bottom: -1rem;
          right: 1rem;
          color: $color__white;
          text-decoration: underline;
          font-weight: $base-text-font-weight-semi-bold;
          cursor: pointer;
          display: inline-flex;
          align-items: center;

          .home-hero__text__btn-container--non-english & {
            bottom: 0;
          }

          &:hover {
            text-decoration: none;
          }

          @include breakpoint-down($between_md_lg) {
            position: static;
            margin-top: 1rem;
            color: $color__primary;
          }
        }

        @include breakpoint-down($between_md_lg) {
            display: flex;
            justify-content: flex-end;
            padding-right: 2rem;
          }

          @include breakpoint-down($md) {
            padding-right: 0;
          }

          @include breakpoint-down($between_md_lg) {
            justify-content: flex-start;
          }
        }

      @include breakpoint-up($between_md_lg) {
        &--light {
          color: $color__white;

          h1 {
            color: $color__white;
          }
        }
      }
    }
  }
</style>
